import { useState, useEffect } from 'react';
import styles from '../../salonAccount.module.scss';

const LineItem = ({ item: { title, price, quantity, id }, locale }) => {
  const [thumbnail, setThumbnail] = useState(null);

  useEffect(() => {
    const getThumbnail = async () => {
      const response = await fetch('/api/shopify/get-line-item', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, locale }),
      });

      const { data } = await response.json();

      const url = await data?.node?.image?.src;

      if (url) setThumbnail(url);
      else
        setThumbnail(
          'https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg'
        );
    };

    if (id) {
      getThumbnail();
    }
  }, []);

  return (
    <div className={styles.lineItem}>
      <div className={styles.lineItemImage}>
        {thumbnail && <img src={thumbnail} alt={`thumbnail ${title}`} loading="lazy" />}
      </div>
      <div className={styles.lineItemContent}>
        <div className={styles.productName}>{title}</div>
        <div className={styles.productPrice}>{price}</div>
        <div className={styles.productQuantity}>Quantity: {quantity}</div>
      </div>
    </div>
  );
};

export default LineItem;
